import React from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import CollapsibleDisclaimer from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import useLink from 'Hooks/useLink';

const WhatIfClientDisclaimerContainer = () => {
  const { pageContentResource: resource } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const {
    collection,
  } = useLink(
    resource.relationship(fr.relationships.clientDisclaimer.name).link('related'),
    { onError: (e) => displayErrorMessage(e, (e.errors && e.errors[0]?.detail) || 'There was a problem loading the documents.') },
  );

  const disclaimer = collection?.resources().head();

  if (!disclaimer) return null;

  return (<CollapsibleDisclaimer
    disclaimerText={disclaimer.attr('disclaimerAbstract')}
    disclaimerReadMore={disclaimer.attr('disclaimerText')}
  />);
};

export default WhatIfClientDisclaimerContainer;
